export interface CapacityBadgeProps {
  readonly occupied: number;
  readonly capacity: number;
  readonly override?: boolean;
  readonly className?: string;
}

export function CapacityBadge(props: CapacityBadgeProps) {
  const over = props.occupied > props.capacity;
  const tone = over ? "bg-warn-100 text-warn-500" : "bg-muted text-ink-700";
  return (
    <span
      className={`pwz-readout inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${tone} ${props.className ?? ""}`}
      data-testid="capacity-badge"
      title={
        over
          ? `Перебор по вместимости (${props.occupied}/${props.capacity})`
          : `Вместимость ${props.occupied}/${props.capacity}`
      }
    >
      {props.occupied}/{props.capacity}
      {props.override ? <span className="pwz-eyebrow ml-0.5 text-current">ovr</span> : null}
      <span className="sr-only">
        {over ? "Перебор по вместимости площадки" : "В пределах вместимости"}: {props.occupied} из{" "}
        {props.capacity}
      </span>
    </span>
  );
}
